import { render } from "./card-sender-consignee.vue?vue&type=template&id=0c48e3a9&ts=true"
import script from "./card-sender-consignee.vue?vue&type=script&lang=ts"
export * from "./card-sender-consignee.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__